import * as $ from 'jquery';
import { Component, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { LocalStorageService } from './../../../services/infrastructure/local-storage.service';
import { Subscription, forkJoin } from 'rxjs';
import { CppService } from '../../../services/cpp/cpp.service';
import { LoaderService } from '../../../services/infrastructure/loader.service';
import { MasterConstants } from '../../../common/constants/master-constants';
import { ToastrService } from 'ngx-toastr';
import { CommonService } from '../../../services/common/common.service';

@Component({
  selector: 'app-cpp-marketing-program-dashboard',
  templateUrl: './cpp-marketing-program-dashboard.component.html',
  styleUrls: ['./cpp-marketing-program-dashboard.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class CppMarketingProgramDashboardComponent implements OnInit, OnDestroy {

  // Array variables
  manufacturerList: DropdownItem[] = [];
  programList: DropdownItem[] = [];
  programListMaster: DropdownItem[] = [];
  tileViewDataSource: any[] = [];
  uniqueFavoritesManufacturerMap = new Map<string, boolean>();
  // Object variables
  subscription = new Subscription();
  marketingProgramDataSource: any[] = [];
  filterMasterData: any[] = [];

  // Any variables
  headerYear: any;
  years: any;
  months: any;
  selectedManufacturerLength: any;
  selectedProgramsLength: any;

  // Boolean variables
  viewAllSelected = false;

  // Date Assignments
  currentDate = new Date();

  // String Variables
  formattedDate: string;
  activeRecords = 'Y';
  searchPlaceHolder = 'Search Product, Vendor, Ship to location etc.';
  viewType = 'tile';

  //Number Variables
  filterYearsCount = 10;

  // Filter Variables
  filters: any = {
    manufacturer: [],
    programs: [],
    fromYearorder: null,
    fromMonthorder: null,
    toYearorder: null,
    toMonthorder: null,
    fromYearShip: null,
    fromMonthShip: null,
    toYearShip: null,
    toMonthShip: null,
    orderFromDate: null,
    orderToDate: null,
    shipFromDate: null,
    shipToDate: null
  };
  resetFilterValues: any = Object.assign({}, this.filters);


  constructor(
    private cppService: CppService,
    private loaderService: LoaderService,
    private localStorageService: LocalStorageService,
    private toastrService: ToastrService,
    private commonService: CommonService
  ) {
    this.formattedDate = this.getFormattedHeaderDate(this.currentDate);
  }

  /**
   * Formats the header date.
   * @param date The date to format.
   * @returns The formatted date string.
   */
  getFormattedHeaderDate(date: Date): string {
    const dateFormat = new Date(date); // CST (UTC-6)
    let formattedDate = dateFormat.toLocaleString('en-US', {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      hour: 'numeric',
      minute: 'numeric',
      hour12: true,
      timeZone: 'America/Chicago'
    }) + ' CST';

    return formattedDate.replace(/at/gi, "   ").toUpperCase();
  }



  ngOnInit() {
    this.setLocalStorage();
    this.setDateFilters();
    this.getFiltersMasterDataAndGridData();
  }

  /**
   * Sets the local storage values.
   */
  setLocalStorage() {
    // Load header crop year and company code
    if (this.localStorageService.get(MasterConstants.HEADER_CROP_YEAR)) {
      this.headerYear = JSON.parse(this.localStorageService.get(MasterConstants.HEADER_CROP_YEAR));
    }
  }

  /**
   * Sets the date filters for the component.
   */
  setDateFilters() {
    // Generate last 10 years including the current year
    this.years = Array.from({ length: this.filterYearsCount }, (_, i) => this.headerYear - i);
    this.months = Array.from({ length: 12 }, (_, i) => ({
      name: new Intl.DateTimeFormat('en-US', { month: 'short' }).format(new Date(2000, i)),
      value: i + 1
    }));
  }



  toggleTabs(id: any) {
    if (this.viewType != id) {
      this.viewType = id;
      this.clearAllFilter();
    }
  }

  getFiltersMasterDataAndGridData() {
    this.loaderService.setLoaderStatus(true);
    const forkJoinAPIs = [];
    forkJoinAPIs.push(this.cppService.getFilterMasterData());

    if (this.viewType == 'list') {
      forkJoinAPIs.push(this.cppService.getMarketingProgramSummary(this.generateFilters()));
      this.subscription.add(forkJoin(forkJoinAPIs).subscribe((result: any[]) => {
        if (result.length > 0) {
          this.filterMasterData = result[0];
          this.setDropdown(result[0], false);
          this.setGridData(result[1]);
        }
        this.loaderService.setLoaderStatus(false);
      }, () => this.loaderService.setLoaderStatus(false)));
    }
    else {
      forkJoinAPIs.push(this.cppService.getMarketingProgramTileViewSummary(this.generateFilters()));
      this.subscription.add(forkJoin(forkJoinAPIs).subscribe((result: any[]) => {
        if (result.length > 0) {
          this.filterMasterData = result[0];
          this.setDropdown(result[0], false);
          this.tileViewDataSource = result[1];
        }
        this.loaderService.setLoaderStatus(false);
      }, () => this.loaderService.setLoaderStatus(false)));
    }
  }

  /**
   * Fetches the marketing program data.
   */
  getMarketingProgramData() {
    this.loaderService.setLoaderStatus(true);
    this.subscription.add(this.cppService.getMarketingProgramSummary(this.generateFilters()).subscribe((result: any[]) => {
      if (result) {
        this.setGridData(result);
      }
      this.loaderService.setLoaderStatus(false);

    }, error => { this.loaderService.setLoaderStatus(false); }));
  }

  /**
 * Fetches the marketing program Tile View data.
 */
  getMarketingProgramTileData() {
    this.loaderService.setLoaderStatus(true);
    this.subscription.add(this.cppService.getMarketingProgramTileViewSummary(this.generateFilters()).subscribe((result: any[]) => {
      if (result) {
        this.tileViewDataSource = result;
        this.loaderService.setLoaderStatus(false);
      } else {
        this.loaderService.setLoaderStatus(false);
      }
    }, error => { this.loaderService.setLoaderStatus(false); }));
  }

  /**
* download the pdf file
*/
  downloadPogramPdfFile(mediaObjectId) {
    this.loaderService.setLoaderStatus(true);
    this.subscription.add(this.cppService.downloadProgramFile(mediaObjectId).subscribe((result: any[]) => {
      if (result) {
        this.downloadPDF(result);
        this.loaderService.setLoaderStatus(false);
      } else {
        this.loaderService.setLoaderStatus(false);
      }
    }, error => { this.loaderService.setLoaderStatus(false); }));
  }

  downloadPDF(element) {
    this.commonService.base64toFile(element.attachment, 'data:' + element.mimeType, element.fileName + '.' + element.fileType);
  }


  generateFilters() {
    let filters = {
      programsList: this.filters.programs?.length ? this.filters.programs.join(',') : '',
      manufacturerList: this.filters.manufacturer?.length ? this.filters.manufacturer.join(',') : '',
      orderPeriodStartYear: (this.filters.orderFromDate && this.filters.orderToDate) ? this.filters.fromYearorder : 0,
      orderPeriodStartMonth: (this.filters.orderFromDate && this.filters.orderToDate) ? this.filters.fromMonthorder : 0,
      orderPeriodEndYear: (this.filters.orderFromDate && this.filters.orderToDate) ? this.filters.toYearorder : 0,
      orderPeriodEndMonth: (this.filters.orderFromDate && this.filters.orderToDate) ? this.filters.toMonthorder : 0,
      shipPeriodStartYear: (this.filters.shipFromDate && this.filters.shipToDate) ? this.filters.fromYearShip : 0,
      shipPeriodStartMonth: (this.filters.shipFromDate && this.filters.shipToDate) ? this.filters.fromMonthShip : 0,
      shipPeriodEndYear: (this.filters.shipFromDate && this.filters.shipToDate) ? this.filters.toYearShip : 0,
      shipPeriodEndMonth: (this.filters.shipFromDate && this.filters.shipToDate) ? this.filters.toMonthShip : 0,
      isActive: this.activeRecords === 'Y'
    };
    return filters;
  }



  clearAllFilter(istoggle: Boolean = false) {
    this.activeRecords = istoggle ? (this.activeRecords == 'Y' ? 'N' : 'Y') : 'Y';
    this.filters = Object.assign({}, this.resetFilterValues);
    this.setDropdown(this.filterMasterData, true);
    this.selectedManufacturerLength = this.filters.manufacturer.filter(x => x.id != "view - all" && x.selected == true).length;
    this.selectedProgramsLength = this.filters.programs.filter(x => x.id != "view - all" && x.selected == true).length;
    if (this.viewType == 'list') {
      this.getMarketingProgramData();
    } else {
      this.getMarketingProgramTileData();
    }
  }

  setGridData(griddata: any) {
    this.marketingProgramDataSource = griddata;

  }

  /**
   * Sets the dropdown lists for manufacturers and programs.
   * @param result The result data to populate the dropdowns.
   */
  setDropdown(result: any, isfavourite: any) {
    const isActive = this.activeRecords === 'Y';
    let manufacturerList: DropdownItem[] = [];
    let programList: DropdownItem[] = [];
    if (isfavourite) {
      manufacturerList = result.manufacturerList.filter(({ isActive: active }) => active === isActive).map(item => ({
        id: item.marketingBrandId,
        value: item.manufacturer,
        selected: false,
        favorite: this.uniqueFavoritesManufacturerMap.get(item.marketingBrandId) || false
      }));

    } else {
      this.uniqueFavoritesManufacturerMap = new Map(result.manufacturerList.map(({ marketingBrandId, isFavoriteManufacturer }) => [marketingBrandId, isFavoriteManufacturer]));
         manufacturerList = result.manufacturerList.filter(({ isActive: active }) => active === isActive).map(item => ({
           id: item.marketingBrandId,
           value: item.manufacturer,
           favorite: item.isFavoriteManufacturer,
           selected: false
         }));
       }

    programList = result.programsList.filter(({ isActive: active }) => active === isActive).map(x => ({
      id: x.marketingProgramID,
      marketingBrandId: x.marketingBrandId,
      value: x.program,
      selected: false
    }));
    this.filters.programs = programList.map(m => m.id);
    this.filters.manufacturer = manufacturerList.map(m => m.id);

    this.manufacturerList = [
      { id: 'view-all', value: 'ALL', favorite: false, selected: true, marketingBrandId: "" },
      ...manufacturerList.filter(m => m.favorite),
      ...manufacturerList.filter(m => !m.favorite)
    ];
    this.programList = [
      { id: 'view-all', value: 'ALL', favorite: false, selected: true, marketingBrandId: "" },
      ...programList
    ];
    this.programListMaster = { ...this.programList };
  }

  updateProgramDropDown() {
    const isListEmpty = !this.filters.manufacturer.length;
    const previousSelectionMap =  new Map(this.programList.map(({ id, selected }) => [id, selected]));
    const filteredProgramList = Object.values(this.programListMaster || {})
      .filter(({ marketingBrandId }) => 
        (isListEmpty && marketingBrandId) || this.filters.manufacturer.includes(marketingBrandId)
      )
      .map(item => ({ ...item, selected: previousSelectionMap.get(item.id) || false }));

    const isAllSelected = filteredProgramList.every(x => x.selected);  
    this.programList = filteredProgramList.length > 0
      ? [{ id: 'view-all', value: 'ALL', favorite: false, selected: isAllSelected, marketingBrandId: "" }, ...filteredProgramList]
      : filteredProgramList;
    this.selectedProgramsLength = this.programList
      .filter(m => m.selected && m.id !== 'view-all')
      .map(m => m.id).length;
  }
  /**
   * Toggles the selection of a dropdown item.
   * @param item The item to toggle.
   * @param type The type of the item (manufacturer or program).
   */
  toggleSelect(item: DropdownItem, type: any) {
    if (type === "manufacturer") {
      const isViewAll = item.id === 'view-all';
      item.selected = !item.selected;
      let viewAllSelected: boolean;
      if (isViewAll) {
        viewAllSelected = item.selected;
        this.manufacturerList.forEach(m => m.selected = viewAllSelected);
      } else {
        viewAllSelected = this.manufacturerList
          .filter(m => m.id !== 'view-all')
          .every(m => m.selected);

        const viewAllItem = this.manufacturerList.find(m => m.id === 'view-all');
        if (viewAllItem) viewAllItem.selected = viewAllSelected;
      }

      this.filters.manufacturer = this.manufacturerList
        .filter(m => m.selected && m.id !== 'view-all')
        .map(m => m.id);
      this.updateProgramDropDown();
      this.selectedManufacturerLength = this.filters.manufacturer.length;
    } else {
      const isViewAll = item.id === 'view-all';
      item.selected = !item.selected;
      let viewAllSelected: boolean;
      if (isViewAll) {
        viewAllSelected = item.selected;
        this.programList.forEach(m => m.selected = viewAllSelected);
      } else {
        viewAllSelected = this.programList
          .filter(m => m.id !== 'view-all')
          .every(m => m.selected);

        const viewAllItem = this.programList.find(m => m.id === 'view-all');
        if (viewAllItem) viewAllItem.selected = viewAllSelected;
      }
      this.filters.programs = this.programList
        .filter(m => m.selected && m.id !== 'view-all')
        .map(m => m.id);
      this.selectedProgramsLength = this.filters.programs.length;
    }
  }

  /**
   * Toggles the favorite status of a manufacturer.
   * @param element The manufacturer item.
   * @param event The mouse event.
   */
  toggleFavorite(element: DropdownItem, event: MouseEvent) {
    event.stopPropagation(); // Prevent dropdown from closing
    element.favorite = !element.favorite;
    this.reorderList();
    this.toggleFavoriteManufacturer(element.id, element.favorite);
  }

  /**
   * Reorders the manufacturer list based on favorite status.
   */
  reorderList() {
    const viewAllSelected = this.manufacturerList.find(m => m.id === 'view-all')?.selected;
    this.manufacturerList = [
      { id: 'view-all', value: 'ALL', favorite: false, selected: viewAllSelected, marketingBrandId: "" },
      ...this.manufacturerList.filter(m => m.favorite && m.id !== 'view-all'),
      ...this.manufacturerList.filter(m => !m.favorite && m.id !== 'view-all')
    ];
  }

  /**
   * Applies the filters for order or ship dates.
   * @param value The type of filter to apply ('order' or 'ship').
   */
  applyFilters(value: 'order' | 'ship') {
    const isOrder = value === 'order';

    const fromYear = isOrder ? this.filters.fromYearorder : this.filters.fromYearShip;
    const fromMonth = isOrder ? this.filters.fromMonthorder : this.filters.fromMonthShip;
    const toYear = isOrder ? this.filters.toYearorder : this.filters.toYearShip;
    const toMonth = isOrder ? this.filters.toMonthorder : this.filters.toMonthShip;

    // Create date ranges only if both year and month are provided
    const fromDate = (fromYear !== null && fromMonth !== null) ? new Date(fromYear, fromMonth, 1) : null;
    const toDate = (toYear !== null && toMonth !== null) ? new Date(toYear, toMonth + 1, 0) : null;

    if (isOrder) {
      this.filters.orderFromDate = fromDate;
      this.filters.orderToDate = toDate;
    } else {
      this.filters.shipFromDate = fromDate;
      this.filters.shipToDate = toDate;
    }
  }


  checkDateValidation() {
    let status = false;
    if (this.filters.orderFromDate && this.filters.orderToDate && this.filters.orderFromDate > this.filters.orderToDate) {
      this.toastrService.error('Invalid Order Period date range: "From" date must be before or equal to "To" date.');
      status = true;
    }
    if (this.filters.shipFromDate && this.filters.shipToDate && this.filters.shipFromDate > this.filters.shipToDate) {
      this.toastrService.error('Invalid Ship Period date range: "From" date must be before or equal to "To" date.');
      status = true;
    }
    let iserror = false;

    const isPartial = (a, b, c, d) => !!(a || b || c || d) && !(a && b && c && d);

    if (isPartial(this.filters.fromYearorder, this.filters.fromMonthorder, this.filters.toYearorder, this.filters.toMonthorder)) {
      this.toastrService.error('Please select both the From and To months and years to apply the filter.');
      status = true;
      iserror = true;
    }

    if (!iserror && isPartial(this.filters.fromYearShip, this.filters.fromMonthShip, this.filters.toYearShip, this.filters.toMonthShip)) {
      this.toastrService.error('Please select both the From and To months and years to apply the filter.');
      status = true;
    }

    return status;
  }

  setFilterData() {
    if (this.checkDateValidation()) {
      return;
    }
    if (this.viewType == 'list') {
      this.getMarketingProgramData();
    } else {
      this.getMarketingProgramTileData();
    }
  }


  // Toggle active records From Active to Inactive Or Vice Versa
  toggleAcitveRecords() {
    this.toastrService.warning('All Filters have been reset as change in Active / In Active');
    this.clearAllFilter(true);
  }

  // Toggle favorite manufacturer in Filters
  toggleFavoriteManufacturer(marketingBrandId: string, favorite: boolean) {
    this.subscription.add(this.cppService.toggleFavoriteManufacturerUrl(marketingBrandId).subscribe((result: any) => {
      if (!result) {
        this.toastrService.error('Something went wrong.');
      }
      this.uniqueFavoritesManufacturerMap.set(marketingBrandId, favorite);
    }, error => { this.loaderService.setLoaderStatus(false); }));
  }

  // Toggle favorite item in Grid
  toggleFavoriteItem(itemID: number) {
    this.loaderService.setLoaderStatus(true);
    this.subscription.add(this.cppService.toggleFavoriteItem(itemID).subscribe((result: any) => {
      if (result) {
        this.setFavoriteProduct(itemID);
        this.loaderService.setLoaderStatus(false);
      } else {
        this.toastrService.error('Something went wrong.');
        this.loaderService.setLoaderStatus(false);
      }
    }, error => { this.loaderService.setLoaderStatus(false); }));
  }

  setFavoriteProduct(itemID: number) {
    if (this.viewType == 'list') {
      this.marketingProgramDataSource.filter(x => x.itemID == itemID).forEach(x => {
        x.isFavoriteProduct = !x.isFavoriteProduct
      });
    } else {
      this.tileViewDataSource.forEach(tileView => {
        tileView.programGroupBy.forEach(programGroup => {
          programGroup.mpItems.forEach(item => {
            if (item.itemID === itemID) {
              item.isFavoriteProduct = !item.isFavoriteProduct;
            }
          });
        });
      });
    }

  }


  // On page destroy
  ngOnDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

}
export interface DropdownItem {
  id: string;
  value: string;
  favorite: boolean;
  selected: boolean;
  marketingBrandId: string;
}
